import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Copy, Code } from 'lucide-react';
import { toast } from 'sonner';

interface EmbedCodeGeneratorProps {
  token: string;
  organizationId?: string;
}

export const EmbedCodeGenerator: React.FC<EmbedCodeGeneratorProps> = ({ 
  token, 
  organizationId 
}) => {
  const getEmbedCode = () => {
    return `<script 
  src="${window.location.origin}/widget/hive360-widget.js" 
  data-org="${organizationId}" 
  data-token="${token}"
  async>
</script>`;
  };

  const copyEmbedCode = () => {
    navigator.clipboard.writeText(getEmbedCode());
    toast.success('Embed code copied to clipboard');
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <Code className="h-4 w-4 mr-2" />
          Get Code
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Widget Embed Code</DialogTitle>
          <DialogDescription>
            Copy this code and paste it into your website where you want the widget to appear.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-gray-50 border rounded-lg p-4 font-mono text-sm overflow-x-auto">
            <pre>{getEmbedCode()}</pre>
          </div>
          
          <div className="flex gap-2">
            <Button onClick={copyEmbedCode} className="flex-1">
              <Copy className="h-4 w-4 mr-2" />
              Copy Embed Code
            </Button>
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-medium text-blue-900 mb-2">Integration Instructions</h4>
            <ol className="text-sm text-blue-700 space-y-1 list-decimal list-inside">
              <li>Copy the embed code above</li>
              <li>Paste it into your website's HTML where you want the widget</li>
              <li>The widget will automatically load and display your classes</li>
              <li>Test enrollment functionality thoroughly before going live</li>
            </ol>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};